import { Link } from "react-router-dom";
import styled from "styled-components/macro";

const Wrapper = styled.div`
  padding: 10px 20px;
  background: transparent;
`;
const StyledLogo = styled.div`
  padding: 0px 0px 0px 30px;
  text-align: left;
  display: flex;
  align-items: center;
  font-family: "DM Sans", serif;
  color: ${({ theme }) => theme.profileText};
  div:first-child {
    font-size: 26px;
    font-weight: 300;
    margin-bottom: 6px;
  }
  div:last-child {
    font-size: 14px;
  }
  @media screen and (max-width: 1000px) {
    padding: 0px 0px 0px 0px;
    width: 100%;
    span {
      float: left;
    }
  }
`;

const Logo = () => {
  return (
    <Wrapper>
      <StyledLogo>
        <Link to={"/"}>
          <img
            style={{
              borderRadius: 100,
              border: "2px solid white",
              marginRight: 10,
            }}
            className="profile"
            src={`${process.env.REACT_APP_S3_BASE_URL}me.jpeg`}
            alt={"profile"}
            height={50}
          />
        </Link>
        <span style={{ fontWeight: "bold", marginTop: 5 }}>
          Alexandra Veres<div>Frontend Engineer</div>
        </span>
      </StyledLogo>
    </Wrapper>
  );
};

const StyledMobileLogo = styled.div<{ hide?: boolean }>`
  display: none !important;
  @media screen and (max-width: 1000px) {
    display: ${({ hide }) => (hide ? "none" : "block !important")};
    margin-top: -50px;
    background: transparent !important;
    width: 100%;
  }
`;

type MobileLogoProps = {
  hide?: boolean;
};

export const MobileLogo = ({ hide }: MobileLogoProps) => (
  <StyledMobileLogo hide={hide}>
    <Logo />
  </StyledMobileLogo>
);

export default Logo;
